"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var years_1 = require("../../../calculation/years");

var constants_1 = require("../constants");

var constants_2 = require("../constants");

var pattern_1 = require("../../../utils/pattern");

var AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

var PATTERN = new RegExp("(?:am\\s*?)?" + "(?:den\\s*?)?" + "([0-9]{1,2})\\." + "(?:\\s*(?:bis(?:\\s*(?:am|zum))?|\\-|\\\u2013|\\s)\\s*([0-9]{1,2})\\.?)?\\s*" + "(".concat(pattern_1.matchAnyPattern(constants_1.MONTH_DICTIONARY), ")") + "(?:(?:-|/|,?\\s*)(".concat(constants_2.YEAR_PATTERN, "(?![^\\s]\\d)))?") + "(?=\\W|$)", "i");
var DATE_GROUP = 1;
var DATE_TO_GROUP = 2;
var MONTH_NAME_GROUP = 3;
var YEAR_GROUP = 4;

var DEMonthNameLittleEndianParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(DEMonthNameLittleEndianParser, _AbstractParserWithWo);

  var _super = _createSuper(DEMonthNameLittleEndianParser);

  function DEMonthNameLittleEndianParser() {
    _classCallCheck(this, DEMonthNameLittleEndianParser);

    return _super.apply(this, arguments);
  }

  _createClass(DEMonthNameLittleEndianParser, [{
    key: "innerPattern",
    value: function innerPattern() {
      return PATTERN;
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var result = context.createParsingResult(match.index, match[0]);
      var month = constants_1.MONTH_DICTIONARY[match[MONTH_NAME_GROUP].toLowerCase()];
      var day = parseInt(match[DATE_GROUP]);

      if (day > 31) {
        match.index = match.index + match[DATE_GROUP].length;
        return null;
      }

      result.start.assign("month", month);
      result.start.assign("day", day);

      if (match[YEAR_GROUP]) {
        var yearNumber = constants_2.parseYear(match[YEAR_GROUP]);
        result.start.assign("year", yearNumber);
      } else {
        var year = years_1.findYearClosestToRef(context.refDate, day, month);
        result.start.imply("year", year);
      }

      if (match[DATE_TO_GROUP]) {
        var endDate = parseInt(match[DATE_TO_GROUP]);
        result.end = result.start.clone();
        result.end.assign("day", endDate);
      }

      return result;
    }
  }]);

  return DEMonthNameLittleEndianParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = DEMonthNameLittleEndianParser;